import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  CardActionArea,
  Grid,
  Typography,
  Chip,
  Stack,
} from '@mui/material';
import { navigationMenuItems } from '../config/navigationMenu';

type EstiloModulo = {
  color: string;
  descripcion: string;
};

const estilosPorModulo: Record<string, EstiloModulo> = {
  Indicadores: {
    color: '#7c3aed',
    descripcion: 'Vista ejecutiva con métricas y evolución de ventas, compras y cobranzas.',
  },
  Ventas: {
    color: '#22a36a',
    descripcion: 'Gestión integral de clientes, pedidos, remitos, facturas e informes comerciales.',
  },
  Compras: {
    color: '#00a0b9',
    descripcion: 'Operación de proveedores, órdenes, remitos, facturas y reportes de compras.',
  },
  Inventario: {
    color: '#8b5cf6',
    descripcion: 'Control de productos, stock, ajustes, transferencias e informes de depósito.',
  },
  Tesorería: {
    color: '#ef4444',
    descripcion: 'Administración de cobranzas, pagos, bancos, movimientos e informes financieros.',
  },
  Contabilidad: {
    color: '#0369a1',
    descripcion: 'Libro diario, plan de cuentas imputable y parametrización contable.',
  },
};

const MenuModulos: React.FC = () => {
  const navigate = useNavigate();
  const modulosOrdenados = [
    ...navigationMenuItems.filter((item) => item.text !== 'Indicadores'),
    ...navigationMenuItems.filter((item) => item.text === 'Indicadores'),
  ];

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, bgcolor: '#f3f4f6', minHeight: '100vh' }}>
      <Grid container spacing={2.5}>
        {modulosOrdenados.map((modulo) => {
          const estilo = estilosPorModulo[modulo.text] ?? {
            color: '#64748b',
            descripcion: 'Acceso a opciones y submenús del módulo.',
          };

          return (
          <Grid item xs={12} md={6} lg={4} key={modulo.text}>
            <Card
              sx={{
                borderRadius: 3,
                border: '1px solid #e5e7eb',
                boxShadow: '0 2px 10px rgba(15, 23, 42, 0.06)',
                height: '100%',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-3px)',
                  boxShadow: '0 8px 22px rgba(15, 23, 42, 0.12)',
                },
              }}
            >
              <CardActionArea
                onClick={() => navigate(modulo.path)}
                sx={{ height: '100%', alignItems: 'stretch' }}
              >
              <CardContent sx={{ p: 2.5 }}>
                <Box
                  sx={{
                    width: 52,
                    height: 52,
                    borderRadius: 2,
                    bgcolor: estilo.color,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 2,
                    color: '#fff',
                  }}
                >
                  {modulo.icon}
                </Box>

                <Typography variant="h6" sx={{ fontWeight: 700, color: '#111827', mb: 1 }}>
                  {modulo.text}
                </Typography>
                <Typography sx={{ color: '#6b7280', minHeight: 52, mb: 2 }}>
                  {estilo.descripcion}
                </Typography>

                <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" sx={{ mb: 2 }}>
                  {modulo.subItems?.map((submenu) => (
                    <Chip
                      key={submenu.path}
                      size="small"
                      variant="outlined"
                      label={submenu.text}
                      clickable
                      onClick={(event) => {
                        event.stopPropagation();
                        navigate(submenu.path);
                      }}
                      sx={{
                        borderColor: '#d1d5db',
                        color: '#374151',
                        '&:hover': { borderColor: estilo.color, color: estilo.color },
                      }}
                    />
                  ))}
                </Stack>
              </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        )})}
      </Grid>
    </Box>
  );
};

export default MenuModulos;
